// extracted by mini-css-extract-plugin
export default {"form-container":"form_form-container__dImtU"};